import CourseInfo from './CourseInfo';
import KommoLiveChat from '../home01/KommoLiveChat';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useState, useEffect } from 'react';

const CourseProgramLayout = ({
    headingTitle,
    showPageHeading = true,
    showEnrollmentSteps = true,
    items,
    selectedCourse,
    selectedMeetKey = null,
    meetItems,
    selectedItem,
    onSelectItem,
}) => {

    const [stepsComplete, setStepsComplete] = useState(false);

    //LOG SECECT CARD COURSE
    // useEffect(() => {
    //     if (!selectedItem) return;

    //     console.log('selected course card:', selectedItem);
    // }, [selectedItem]);

    useEffect(() => {
        if (!stepsComplete) return;
        if (!items?.length) return;
        if (selectedItem) return;

        const first = items[0];
        onSelectItem(first);
    }, [stepsComplete, items, onSelectItem]);

    if (!selectedCourse) return null;

    return (
        <div className="tutori-course-content tab-style-1">
            <div className="">
                <div className="row">
                    <div className="course-sidebar col-lg-7 col-xl-8">
                        <div className="course-widget">
                            {showPageHeading && (
                                <h1 className="course-title mb-4">{headingTitle}</h1>
                            )}

                            <div className={`enrollment-transition ${stepsComplete ? 'is-complete' : 'is-empty'}`}>
                                {showEnrollmentSteps && !stepsComplete && (
                                    <div className="course-enrollment-steps card border-0 shadow-sm mb-4">
                                        <div className="card-body">
                                            <h4 className="">Belum ada program yang kamu pilih.</h4>
                                            <h5 className="">Mulai isi form untuk menampilkan program yang tersedia</h5>
                                            <img src="assets/images/banner/skeleton.png" alt="skeleton-program-unavailable" className='img-fluid' />
                                        </div>
                                    </div>
                                )}

                                {stepsComplete && (
                                    <div className="program-grid-2">
                                        {items.map((item) => {
                                            const isSelected = selectedItem?.id_ui === item.id_ui;
                                            return (
                                                <div
                                                    key={item.id_ui}
                                                    className={`program-card${isSelected ? ' program-card--selected' : ''}`}
                                                    role="button"
                                                    tabIndex={0}
                                                    onClick={() => onSelectItem(item)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            onSelectItem(item);
                                                        }
                                                    }}
                                                >
                                                    {isSelected && (
                                                        <span className="program-badge">
                                                            Dipilih
                                                        </span>
                                                    )}
                                                    <img
                                                        src={`/assets/images/course/course-01/${item.image}`}
                                                        alt={item.title}
                                                        className="program-image"
                                                    />

                                                    <div className="program-content">
                                                        <h3 className="program-title">{item.title}</h3>
                                                        <p className="program-body">{item.subtitle || ''}</p>
                                                        <span className="fs-desc">
                                                            <a
                                                                href={`/course-details/${item.id_detail}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                Lihat Detail <MdKeyboardArrowRight />
                                                            </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>

                    <div className="col-lg-5 col-xl-4">
                        <CourseInfo
                            data={selectedCourse}
                            initialSelectedMeet={selectedMeetKey}
                            omitBasicsFields={false}
                            selectedCourseTitle={selectedCourse?.title ?? ''}
                            selectedItem={selectedItem}
                            onEnrollmentComplete={setStepsComplete}
                            showPrice={stepsComplete}
                            meetItems={meetItems}
                            onSelectItem={onSelectItem}
                        />
                    </div>
                    <KommoLiveChat />
                </div>
            </div>
        </div>
    );
};

export default CourseProgramLayout;
